import { render, staticRenderFns } from "./VLeadListItem.vue?vue&type=template&id=22e84e7c"
import script from "./VLeadListItem.vue?vue&type=script&lang=js"
export * from "./VLeadListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports